module.exports = __webpack_public_path__ + "img/2.6c8d0a0a.jpg";